<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="1" id="note-on-pronunciation">
<h1 data-number="1">Note on Pronunciation</h1>
<p>Irish is different to English, and Ancient Irish is more different still. It seems harsh to ask a reader to learn a new system of spelling and pronunciation in order to be able to follow a story. Where a name has a recognizable equivalent in English I have used it. Thus Derdriu in the original (pronounced <strong>Der</strong>-dru) is here given as Deirdre. Maeve is the English spelling of Medb, and pronounced much the same. Where a name has no obvious equivalent, such as Setanta (pronounced <strong>Shay</strong>-dan-da), I have tried to use a form that is memorable for the reader.</p>
<p>For those (like me) who like to know such things, the following rough guide to Irish pronunciation may be useful. Bold type indicates a stressed syllable.</p>
<p class="hanging_indent_pronunciation_first">Ailill: <strong>Al</strong>-il</p>
<p class="hanging_indent_pronunciation">Cathbad: <strong>Kaff</strong>-a</p>
<p class="hanging_indent_pronunciation">Cuchullain: Koo-h<strong>ull</strong>-in</p>
<p class="hanging_indent_pronunciation">Emer: <strong>Ay</strong>-ver</p>
<p class="hanging_indent_pronunciation">Ferdia: Fer-<strong>di</strong>-a</p>
<p class="hanging_indent_pronunciation">Laeg: <strong>Loy</strong>gh</p>
<p class="hanging_indent_pronunciation">Naisi: <strong>Noy</strong>-shu</p>
<p class="hanging_indent_pronunciation">Sualdam: <strong>Soo</strong>-al-dav</p>
<p class="hanging_indent_pronunciation">Emain Macha: <strong>Ev</strong>-in <strong>Ma</strong>-cha</p>
<p class="hanging_indent_pronunciation">Iraird Cuillenn: <strong>Ir</strong>-ard <strong>Kwil</strong>-en</p>
<p class="hanging_indent_pronunciation">Sliab Fuait: <strong>Shlee</strong>-av <strong>Food</strong>-id</p>
<p class="no_indent_top_space">There are a dozen different ways to spell Shakespeare, but there is only one <em>Hamlet.</em> The Irish Heroes wished their names and their deeds to live for all time. So long as we remember them and tell their stories, we honour them. Even if we don’t say their names exactly right.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?53b1b82e